import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  CreateItemApiModel,
  TotalHoursApiModel,
  TrainingCourseApiModel,
  TrainingCourseBasicInformationApiModel,
  TrainingCourseContentApiModel,
  TrainingCourseListApiModel,
  TrainingCourseSelectorsApiModel,
  TrainingCoursesReportRequestApiModel,
  TrainingCoursesRequestApiModel
} from '@app/api/api-models';
import { toQueryParams } from '@app/shared/utils';
import { HttpClientService } from '@app/api/api-services/http-client.service';
import { ITotalHoursCourses } from '@app/api/api-models/reports/training-reports/TotalHoursCourses.interface';
import { ITotalHoursEmployees } from '@app/api/api-models/reports/training-reports/TotalHoursEmployees.interface';

@Injectable()
export class TrainingCoursesService {
  public apiUrl = 'training-courses';

  constructor(private readonly http: HttpClientService) {}

  public getList(request: TrainingCoursesRequestApiModel): Observable<TrainingCourseListApiModel[]> {
    return this.http.get<TrainingCourseListApiModel[]>(`${this.apiUrl}`, { params: toQueryParams(request) });
  }

  public getById(id: number): Observable<TrainingCourseApiModel> {
    return this.http.get<TrainingCourseApiModel>(`${this.apiUrl}/${id}`);
  }

  public getSelectorsById(id: number): Observable<TrainingCourseSelectorsApiModel> {
    return this.http.get<TrainingCourseSelectorsApiModel>(`${this.apiUrl}/${id}/selectors`);
  }

  public create(model: CreateItemApiModel): Observable<TrainingCourseApiModel> {
    return this.http.post<TrainingCourseApiModel>(`${this.apiUrl}`, model);
  }

  public updateBasicInformation(model: TrainingCourseBasicInformationApiModel): Observable<TrainingCourseApiModel> {
    return this.http.put<TrainingCourseApiModel>(`${this.apiUrl}/update-basic-information`, model);
  }

  public updateContent(model: TrainingCourseContentApiModel): Observable<TrainingCourseApiModel> {
    return this.http.put<TrainingCourseApiModel>(`${this.apiUrl}/update-content`, model);
  }

  public delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }

  /*  training courses - total training hours  */

  public getFilters(): Observable<{ Courses: ITotalHoursCourses[]; Employees: ITotalHoursEmployees[] }> {
    return this.http.get(`reports/${this.apiUrl}/filters`);
  }

  public getTrainingCourses(model: TrainingCoursesReportRequestApiModel): Observable<TotalHoursApiModel> {
    return this.http.post<TotalHoursApiModel>(`reports/${this.apiUrl}/report`, model);
  }
}
